// Dependencies
import { useDispatch } from "react-redux";

// Actions
import { ChangePage } from "../../actions/navigation.actions";

/**
 * This hook exposes helper functions for navigating to different pages.
 */
const useNavigate = () => {
	const dispatch = useDispatch<any>();

	const navigate = (path: string) => {
		dispatch(ChangePage(path));
	};

	return navigate;
};

export default useNavigate;
